import styled from "styled-components";
import { CardComp } from "..";
import TablePagination from "../Table/Pagination";

const Footer = styled.div`
  margin-top: 0.5rem;
`;

/**
 * Always surfaces pagination UI when there is data — avoids hidden controls
 * when totalPages was previously gated behind totalPages > 1.
 */
export default function InvestorListPagination({
  currentPage,
  perPage,
  total,
  totalPages,
  count,
  onPageChange,
  marginTop,
}) {
  if (!total) return null;

  return (
    <Footer>
      <CardComp cardClassName="border-0 shadow-sm rounded-4 mt-3 mb-0 pb-3">
        <TablePagination
          currentPage={currentPage}
          perPage={perPage}
          total={total}
          totalPages={totalPages}
          count={count}
          handlePageChange={onPageChange}
          marginTop={marginTop ?? "0.5rem"}
          marginBottom="0"
        />
      </CardComp>
    </Footer>
  );
}
